import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const SubcategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-top: 2rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  
  @media (max-width: 768px) {
    gap: 0.75rem;
    max-width: 400px;
  }
`;

export const SubcategoryLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  max-width: 100px;
  justify-self: center;
  
  @media (min-width: 769px) {
    max-width: 150px;
  }
`;

export const SubcategoryButton = styled(motion.div)`
  border-radius: 15px;
  background: transparent;
  position: relative;
  aspect-ratio: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: visible;
  cursor: pointer;
  
  @media (max-width: 768px) {
    border-radius: 12px;
  }
`;

export const SubcategoryImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  border-radius: 15px;
  
  @media (max-width: 768px) {
    border-radius: 12px;
  }
`;

export const SubcategoryPlaceholder = styled.div`
  padding: 2rem;
  text-align: center;
  background: ${props => props.background};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
`;

export const PlaceholderTitle = styled.h3`
  margin: 0.5rem 0 0 0;
  font-size: 1rem;
`;

